/* ─────────────────────────────────────────────────────────────────────────
   Cozy Cup Club — Theme JS.
   Plain modules, no framework. Each block is independent and re-runs
   safely on Customizer section reload (shopify:section:load events).
───────────────────────────────────────────────────────────────────────── */

(function () {
  'use strict';

  /* ─── Header scrolled state ─────────────────────────────────────────── */
  function bindHeaderScroll(header) {
    if (!header || header.dataset.scrollBound === 'true') return;
    header.dataset.scrollBound = 'true';

    var update = function () {
      if (window.scrollY > 20) {
        header.classList.add('is-scrolled');
      } else {
        header.classList.remove('is-scrolled');
      }
    };

    update();
    window.addEventListener('scroll', update, { passive: true });
  }

  /* ─── Mobile drawer ─────────────────────────────────────────────────── */
  function bindMobileToggle(toggle) {
    if (!toggle || toggle.dataset.toggleBound === 'true') return;
    toggle.dataset.toggleBound = 'true';

    var drawer = document.querySelector('[data-mobile-drawer]');
    var iconMenu = toggle.querySelector('[data-toggle-icon="menu"]');
    var iconClose = toggle.querySelector('[data-toggle-icon="close"]');
    if (!drawer) return;

    toggle.addEventListener('click', function () {
      var isOpen = drawer.classList.toggle('is-open');
      toggle.setAttribute('aria-expanded', String(isOpen));
      if (iconMenu) iconMenu.hidden = isOpen;
      if (iconClose) iconClose.hidden = !isOpen;
    });

    // Close drawer when a nav link is tapped
    drawer.querySelectorAll('a').forEach(function (link) {
      link.addEventListener('click', function () {
        drawer.classList.remove('is-open');
        toggle.setAttribute('aria-expanded', 'false');
        if (iconMenu) iconMenu.hidden = false;
        if (iconClose) iconClose.hidden = true;
      });
    });
  }

  /* ─── Reveal on scroll ──────────────────────────────────────────────── */
  function bindReveal() {
    var els = document.querySelectorAll('.reveal:not([data-reveal-bound])');
    if (els.length === 0) return;

    var prefersReduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (prefersReduced || !('IntersectionObserver' in window)) {
      els.forEach(function (el) {
        el.classList.add('is-visible');
        el.dataset.revealBound = 'true';
      });
      return;
    }

    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          observer.unobserve(entry.target);
        }
      });
    }, {
      rootMargin: '0px 0px -10% 0px',
      threshold: 0.1
    });

    els.forEach(function (el) {
      el.dataset.revealBound = 'true';
      observer.observe(el);
    });
  }

  /* ─── Password page: open staff gate via hash or query (bookmarkable) ─ */
  function bindPasswordStaffGate() {
    var details = document.querySelector('[data-password-gate-details]');
    if (!details || details.dataset.passwordGateBound === 'true') return;
    details.dataset.passwordGateBound = 'true';

    var hash = window.location.hash.toLowerCase();
    var params = new URLSearchParams(window.location.search);
    var open =
      hash === '#staff' ||
      hash === '#preview' ||
      params.get('staff') === '1';

    if (open) {
      details.open = true;
      window.requestAnimationFrame(function () {
        var input = details.querySelector('input[type="password"]');
        if (input) input.focus();
      });
    }
  }

  /* ─── Marquee ──────────────────────────────────────────────────────────
     The announcement bar duplicates its items in Liquid (see
     sections/promo-bar.liquid `{% for pass in (1..2) %}`) so the
     translateX(-50%) keyframe in components.css produces a seamless loop
     with zero JS state. Reduce-motion users get a centered static
     fallback via @media (prefers-reduced-motion: reduce) in
     components.css, which hides the duplicated copy. */

  /* ─── Boot ──────────────────────────────────────────────────────────── */
  function boot() {
    bindHeaderScroll(document.querySelector('[data-site-header]'));
    bindMobileToggle(document.querySelector('[data-mobile-toggle]'));
    bindReveal();
    bindPasswordStaffGate();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  /* ─── Customizer hooks ─────────────────────────────────────────────────
     Re-bind when sections are reloaded inside the Theme Editor so live
     edits don't lose JS behavior. */
  document.addEventListener('shopify:section:load', boot);
  document.addEventListener('shopify:section:select', boot);
})();
